import styled, { css, keyframes } from 'styled-components';
import colors from '../../assets/styled/colors';
import { progressTokens } from '../../tokens/components/Progress/tokens';

const shimmerRoll = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
`;

const slidein = keyframes`
  from { width: initialWidth; }
  to { width: finalWidth; }
`;

export const ProgressBarWrapper = styled.div`
  background-color: ${progressTokens.CoreBackgroundDefault};
  border-radius: ${progressTokens.CoreBorderRadiusDefault};
  margin-bottom: 8px;
  overflow: hidden;
  position: relative;

  ${({ theme }) =>
    theme.size === 'small' &&
    css`
      height: ${progressTokens.CoreSizeBarSmall};
    `}

  ${({ theme }) =>
    theme.size === 'large' &&
    css`
      height: ${progressTokens.CoreSizeBarLarge};
    `}

  ${({ theme }) =>
    theme.loading &&
    css`
      animation-duration: 1s;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
      animation-name: ${shimmerRoll};
      animation-timing-function: linear;
      background: ${progressTokens.CoreBackgroundShimmerPrimary};
      background-image: linear-gradient(
        90deg,
        ${progressTokens.CoreBackgroundShimmerPrimary} 0%,
        ${progressTokens.CoreBackgroundShimmerSecondary} 50%,
        ${progressTokens.CoreBackgroundShimmerPrimary} 100%
      );
      background-repeat: no-repeat;
      position: relative;
      width: 100%;

      ${theme.size === 'small'
        ? css`
            background-size: 400px ${progressTokens.CoreSizeBarSmall};
            height: ${progressTokens.CoreSizeBarSmall};
          `
        : css`
            background-size: 400px ${progressTokens.CoreSizeBarLarge};
            height: ${progressTokens.CoreSizeBarLarge};
          `}
    `}
`;

export const ProgressBarData = styled.div`
  height: 100%;
  position: absolute;

  ${({ theme }) =>
    css`
      background-color: ${theme.color === 'gray-darker' ? progressTokens.CoreColorGray : colors[theme.color]};
      border-radius: ${progressTokens.CoreBorderRadiusDefault};

      ${theme.size === 'small'
        ? css`
            width: calc((100% * ${({ theme }) => theme.width}) + ${progressTokens.CoreSizeCapSmall});
          `
        : css`
            width: calc((100% * ${({ theme }) => theme.width}) + ${progressTokens.CoreSizeCapLarge});
          `}
    `};

  &:not(:first-of-type) {
    border-radius: ${progressTokens.CoreBorderRadiusNone};
    width: calc(100% * ${({ theme }) => theme.width});
  }
`;

export const ProgressWrapper = styled.div`
  width: 100%;

  ${({ theme }) =>
    theme.progressTrim &&
    css`
      ${ProgressBarWrapper} {
        margin-bottom: 0;
      }
    `}

  ${({ theme }) =>
    theme.animated &&
    css`
      ${ProgressBarData} {
        animation-name: ${slidein};
        transition-duration: 1s;
        transition-property: width;
        transition-timing-function: ease-in;
      }
    `}
`;

export const ProgressLegendItemWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const ProgressLegendWrapper = styled.ul`
  margin: 8px 0;
`;

export const ProgressLegendEntry = styled.li`
  display: inline-block;
  margin-right: 20px;
`;

export const ProgressLegendItemIcon = styled.span`
  ${({ theme }) =>
    theme.size === 'small' &&
    css`
      height: ${progressTokens.CoreSizeIconSmall};
      margin-right: ${progressTokens.CoreSizeIconSmall};
      width: ${progressTokens.CoreSizeIconSmall};
    `}

  ${({ theme }) =>
    theme.size === 'large' &&
    css`
      height: ${progressTokens.CoreSizeIconLarge};
      margin-right: ${progressTokens.CoreSizeIconLarge};
      width: ${progressTokens.CoreSizeIconLarge};
    `}

  ${({ theme }) =>
    theme.type === 'circle' &&
    css`
      border-radius: 50%;
    `}

  ${({ theme }) => css`
    background-color: ${theme.color === 'gray-darker' ? progressTokens.CoreColorGray : colors[theme.color]};
  `}
`;

export const ProgressLegendItemLabel = styled.span`
  color: ${progressTokens.CoreColorLegend};
  font-size: ${progressTokens.CoreFontSizeBaseDefault};
  font-weight: ${progressTokens.CoreFontWeightBaseDefault};
  line-height: ${progressTokens.CoreFontLeadingBaseDefault};
`;
